import BlockedIcon from '@/assets/images/icons/BlockedIcon.svg'
import { Base } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { useShowBilling } from '@/hooks'
import { useIsReverStaff } from '@/hooks/use-is-rever-staff'

const { Button } = Base

export const BlockedDashboardOverlay = () => {
  const { t } = useTranslation()
  const showBilling = useShowBilling()
  const isStaff = useIsReverStaff()
  // Staff open blocked merchants' dashboards to help them.
  if (isStaff) return null
  return (
    <div
      className="fixed left-[240px] z-50 flex items-center justify-center rounded-[20px] bg-black/20 backdrop-blur-sm"
      style={{
        width: 'calc(100vw - 240px - 8px)',
        height: 'calc(100vh - 16px)',
        top: '8px'
      }}
    >
      <div className="relative flex w-full max-w-[400px] flex-col items-center justify-center gap-4 rounded-xl bg-white p-8">
        <div className="absolute left-1/2 top-[-40px] flex size-[80px] -translate-x-1/2 items-center justify-center rounded-full bg-white">
          <img src={BlockedIcon} alt="Blocked" className="size-[40px]" />
        </div>
        <h1 className="mt-4 font-[Roobert] text-2xl font-medium leading-6 text-neutral-900">
          {t('blocked_overlay.title')}
        </h1>
        <p className="text-center text-neutral-500">
          {t('blocked_overlay.description')}
        </p>

        <Button
          variant="primary"
          render={
            showBilling ? (
              <Link to="/billing" className="w-full text-center" />
            ) : (
              <a
                href="mailto:invoice@itsrever.com"
                className="w-full text-center"
              />
            )
          }
        >
          {t('blocked_overlay.cta')}
        </Button>
      </div>
    </div>
  )
}
